import React, { useState } from 'react';
import {
  Dialog,
  Button,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { poppins500, poppins400 } from 'theme/common.style';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { useHistory } from 'react-router-dom';
import { getApiCall } from 'api/apiService';
import { GET_DEPOSIT } from 'constant/app.config';
import DepositPaymentDetailsNew from 'component/BuyerRegistration/components/DepositPaymentDetailsNew';

const WarningIconYELLOW = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#FF9500"
      />
    </svg>
  );
};

const DepositDueNow = ({
  open,
  onClose,
  streetName,
  propertyId,
  individualPage,
  getBuyerIndividualValue,
  setPaymentPop,
  flagSign,
  flagSignStatus,
  setShowActivateTrade,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [depositeopen, setDepositeopen] = React.useState(false);
  const [getDeposit, setGetDeposit] = useState();
  const GetDeposit = () => {
    let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
    getApiCall(`${GET_DEPOSIT.replace(/\/$/, '')}/${propertyId}`, {
      method: 'GET',
      headers: {
        Authorization: accesstoken,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      setGetDeposit(res?.data);
      setDepositeopen(true);
    });
  };
  const history = useHistory();

  const handleDepositPaymentClick = () => {
    if (!individualPage) {
      history.push({
        pathname: `market/${propertyId}`,
        state: { triggerGetDeposit: true },
      });
    } else {
      setShowActivateTrade(true);
      GetDeposit();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            maxWidth: '721px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {streetName}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '18px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Deposit Payment - Due Now
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '14px' : '16px',
                color: '#666666',
              }}
            >
              Your deposit payment for{' '}
              <span>
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {streetName}
                </b>
              </span>{' '}
              is now due. Please process this payment immediately to avoid
              default. 
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              border: '1px solid',
              borderColor: '#FF9500',
              padding: 2,
              mt: matchessm ? '25px' : '30px',
              alignItems: 'center',
              mr: '-30px',
            }}
          >
            <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
              <WarningIconYELLOW fontSize={isXsScreen ? 'small' : 'medium'} />
            </Grid>
            <Grid item xs={10}>
              <Typography
                sx={{
                  ...poppins400,
                  color: '#666666',
                  fontSize: matchessm ? '12px' : '16px',
                }}
              >
                Buyer’s that fail to meet their deposit payment obligations can
                be in breach of their contractual obligations and may face
                serious penalties and or recovery action.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={matchessm ? 1 : 2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={onClose}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  cursor: 'pointer',
                }}
                onClick={handleDepositPaymentClick}
              >
                Deposit Payment
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <DepositPaymentDetailsNew
        open={depositeopen}
        setDepositeopen={setDepositeopen}
        data={getDeposit}
        getBuyerIndividualValue={getBuyerIndividualValue}
        setPaymentPop={setPaymentPop}
      />
    </>
  );
};

export default DepositDueNow;
